<template>
  <div>
    <el-upload
      ref="elUpload"
      action="http://zjk.ciur.org.cn/common/review_file_upload"
      :auto-upload="true"
      :before-upload="beforeUpload"
      :data="{ token: token }"
      :on-change="handleChange"
      :show-file-list="false"
      :on-success="handleSuccess"
    >
      <el-button size="medium" v-if="!isDis">选择文件</el-button>
      <template #tip>
        <div>
          <div class="el-upload__tip"  v-if="!isDis">
            请上传学历学位证书（PDF格式，不超过5M）
          </div>
          <div v-for="(item, index) in fileList" class="file-warp" :key="index">
            <div>{{ item.name }}</div>
            <div>
              <el-button type="text" @click="handleView(item)" v-if="!isDis">预览</el-button>
              <span @click="handleView(item)" style="cursor: pointer;color: #009fff;" v-else>预览</span>
              <el-button type="text" @click="handleRemove(index)"  v-if="!isDis"
                >删除</el-button
              >
            </div>
          </div>
          <div v-if="fileName" class="file-warp"  >{{fileName}}</div>
        </div>
      </template>
    </el-upload>
  </div>
</template>
<script>
import { setPrefix } from '../../../utils/tool'
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    isDis: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.fileList = JSON.parse(JSON.stringify(this.list))
  },
  data () {
    return {
      checked: false,
      url: '',
      fileList: [],
      token: sessionStorage.getItem('Token3'),
      fileName: ''
    }
  },
  methods: {
    beforeUpload (file) {
      const MAX_SIZE = 1024 * 1024 * 5 // 设置最大为10KB
      if (file.size > MAX_SIZE) {
        this.$message({
          message: '文件大小不能超过5MB',
          type: 'info'
        })
        // 处理文件过大的情况，比如清除文件或者禁用上传按钮
        return false
      }
      const hzm = file.name.split('.')
      const hzname = hzm.length ? hzm[hzm.length - 1] : ''
      if (!['pdf'].includes(hzname.toLocaleLowerCase())) {
        this.$message({
          message: '请上传PDF格式',
          type: 'info'
        })
        // 处理文件过大的情况，比如清除文件或者禁用上传按钮
        return false
      }
      this.fileName = file.name
    },
    handleView (item) {
      const resultUrl = setPrefix(item.response.url)
      console.log(item, 'resultUrl')
      window.open(resultUrl)
    },
    handleRemove (index) {
      this.fileList.splice(index, 1)
      this.$emit('update:list', this.fileList)
    },
    handleSuccess (response, file, fileList) {
      // let list = [];
      // list = fileList.map((item) => {
      //   let url = "";
      //   if (item.response?.code === 200) {
      //     url = item.response.url;
      //   }
      //   return {
      //     name: item.name,
      //     url: url,
      //   };
      // });
      // this.$set(this, "fileList", list);
      this.fileName = ''
      this.fileList.push(file)
      this.$emit('update:list', this.fileList)
    },
    handleChange (file, fileList) {
    //   let filterList = fileList.filter((item) => item.uid !== file.uid);

    //     console.log(filterList, "filterList");
    //   const MAX_SIZE = 1024 * 1024 * 5; // 设置最大为10KB
    //   if (file.size > MAX_SIZE) {
    //     //   //   this.$message({
    //     //   //     message: "文件大小不能超过5MB",
    //     //   //     type: "info",
    //     //   //   });
    //     let list = filterList.map((item) => {
    //       return {
    //         name: item.name,
    //         url: item.url,
    //       };
    //     });
    //     this.$set(this, "fileList", list);
    //     this.$emit("update:list", this.fileList);
    //     //   //   // 处理文件过大的情况，比如清除文件或者禁用上传按钮
    //     return false;
    //   }
    //     let hzm = file.name.split(".");
    //     let hzname = hzm.length ? hzm[hzm.length - 1] : "";
    //   //   // console.log(hzname, "file");
    //   if (!["pdf"].includes(hzname.toLocaleLowerCase())) {
    //     let list = filterList.map((item) => {
    //       return {
    //         name: item.name,
    //         url: item.url,
    //       };
    //     });
    //     this.$set(this, "fileList", list);
    //     this.$emit("update:list", this.fileList);
    //   }
    //   //   console.log(33333)
      // this.$set(this, "fileList", fileList);
      // this.fileList.push(file)
      // this.$emit("update:list", this.fileList);
    }
  }
}
</script>
<style scoped>
.file-warp {
  display: flex;
  justify-content: space-between;
}
</style>
